import ApplyMerchantForm from "../components/ApplyMerchantForm/ApplyMerchantForm.vue";
import MerchantApplicationDetails from "../components/Dashboard/MerchantApplications /MerchantApplicationDetails.vue";
import MerchantApplications from "../components/Dashboard/MerchantApplications /MerchantApplications.vue";

const applyRoutes = [
    {
        path: "apply/merchant",
        component: ApplyMerchantForm,
        meta: {
            required: true,
            roles: ["PanelUser", 'AppliedMerchantUser'],
        },
        name: "ApplyMerchantForm",
    },
    {
        path: "apply/merchant/list",
        component: MerchantApplications,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "MerchantApplications",
    },
    {
        path: "apply/merchant/list/:id",
        component: MerchantApplicationDetails,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "MerchantApplicationDetails",
    }
]

export default applyRoutes;